import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { SaleOrderList } from '../TitleList';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { useNavigate } from 'react-router-dom';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { selectCloths, selectFirm, selectItemAvg, selectItems, selectJobRate, selectLogo, selectParty, selectPriPerGrp, selectSalebarcd, selectSchool, selectsono, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchPricePerData } from '../../Store/PHPSlice/Sale/PricePercent';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { useNavigation } from '../NavigationContext';
import { fetchLogoData } from '../../Store/PHPSlice/Logo';
import { fetchTransportData } from '../../Store/PHPSlice/Transport';
import { createSaleOrdEntry, fetchSaleBarcode, fetchSOno } from '../../Store/PHPSlice/Sale/SaleOrder';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import { fetchJobRateData } from '../../Store/PHPSlice/JobRate';




const SaleOrderEntry = () => {

    const [formData, setFormData] = useState({
        sono: '',
        barcode: '',
        orgbarcode: '',
        ordt: getCurrentDate(),
        deldt: '',
        firm: ' ',
        party: ' ',
        price: ' ',
        item: ' ',
        schl: ' ',
        logo: ' ',
        extra: '0',
        totQty: '0',
        discount: '0',
        outSrc: '0',
        transportId: '',
        qty: [],
        size: '',
        jobrate: '',
        userId: '1',

    });
    const clothTypes = ['Main Cloth', 'Matching Cloth-1', 'Matching Cloth-2', 'Matching Cloth-3'];
    const [rows, setRows] = useState(clothTypes.map(type => ({
        clothTypes: type,
        cloth: '',
        rate: '0',
        panna: '0',
        avg: [],
    })));
    const [sizeItem, setSizeItem] = useState([]);
    const [inputValues, setInputValues] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setPreviousPath } = useNavigation();

    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const itemlist = useSelector(selectItems);
    const schlList = useSelector(selectSchool);
    const pricelist = useSelector(selectPriPerGrp);
    const clothlist = useSelector(selectCloths);
    const logolist = useSelector(selectLogo);
    const transptlist = useSelector(selectTransports);
    const sono = useSelector(selectsono);
    const barcode = useSelector(selectSalebarcd);
    const itemAvglist = useSelector(selectItemAvg);
    const jobratelist = useSelector(selectJobRate);
    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchSchoolData());
        dispatch(fetchPricePerData());
        dispatch(fetchClothData());
        dispatch(fetchLogoData());
        dispatch(fetchTransportData());
        dispatch(fetchSOno());
        dispatch(fetchSaleBarcode());
        dispatch(fetchItemAvgData());
        dispatch(fetchJobRateData());
    }, [dispatch]);


    useEffect(() => {
        if (sono) {
            const item = sono.data.SOno || '';
            setFormData(prevFormData => ({
                ...prevFormData,
                sono: item
            }));
        }

        if (inputValues) {
            const sumQty = Object.values(inputValues).reduce((sum, qty) => sum + parseFloat(qty), 0) || '0';
            const convertintoArray = [...Object.values(inputValues).map((val) => val)] || '0';
            setFormData(prevFormData => ({
                ...prevFormData,
                totQty: sumQty,
                qty: convertintoArray
            }));
        }
    }, [sono, inputValues]);

    useEffect(() => {
        if (barcode?.data) {
            const bar = barcode?.data?.sobar;
            setFormData(prevFormData => ({
                ...prevFormData,
                barcode: bar,
                orgbarcode: bar
            }));
        }
    }, [barcode]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleNavitoItem = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewItemEntry');
    };

    const handleNavitoParty = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewPartyEntry');
    };

    const handleNavitoSchool = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewSchoolEntry');
    };

    const handleNavitoLogo = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewLogoEntry');
    };
    const handleNavitoTransport = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewTransportEntry');
    };

    const handleNavitoCloth = () => {
        // window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        setPreviousPath(window.location.pathname);
        navigate('/NewClothEntry');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        // Update form data with the selected dropdown value
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));
        if (dropdownType === 'item' && value) {
            const selectedjobrate = jobratelist.data.length > 0 ? jobratelist.data.find((val) => val.itemId === value) : '';
            if (selectedjobrate) {
                const jobrate = selectedjobrate.total || 0;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    jobrate: jobrate
                }));
            }
        }

    };



    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };


    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

    };


    const handleDropdownChanged = (event, index, fieldName) => {
        const { value } = event.target;

        if (fieldName === 'cloth' && value) {

            // Find the selected cloth in clothlist
            const selectedSizes = itemlist.data.length > 0 ? itemlist.data.find((val) => val.ID === formData.item) : [];
            if (selectedSizes) {
                const item = selectedSizes.size;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    size: item
                }));
            }
            if (selectedSizes) {
                const item = selectedSizes.size;
                const sizeArray = item.split(",");
                setSizeItem(sizeArray);

                const selectedCloth = clothlist.data.length > 0 ? clothlist.data.find(cloth => cloth.ID === value) : null;

                // Get the rate and panna size for the selected cloth
                const rate = selectedCloth ? selectedCloth.rate : 0;
                const panna = selectedCloth ? selectedCloth.panna_size : 0;

                // Select the average values based on item ID and panna size
                const selectAvgValues = itemAvglist.data.length > 0
                    ? itemAvglist.data.filter(val => val.itemId === formData.item && val.panna_size === panna)
                    : [];

                // Map to get an array of average values
                const avg = [...selectAvgValues.map(val => val.avg)];


                const updatedRows = rows.map((row, i) => {
                    if (i === index) {
                        return { ...row, [fieldName]: value, rate, panna, avg };
                    }
                    return row;
                });

                setRows(updatedRows);

            } else {
                alert('Select the Item');
            }


        }
    };

    const handleInputChanged = (event, index) => {
        const { value, name } = event.target;
        // Update the row data based on index and name (e.g., 'rate')
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [name]: value } : row
        );
        setRows(updatedRows); // Assume setRows updates your rows state
    };

    const handleQtyChange = (index, event) => {
        const value = event.target.value;
        setInputValues(prevValues => {
            // Update the state with the new value
            const newValues = { ...prevValues, [index]: value };
            // Remove the entry if the value is empty
            if (!value) {
                delete newValues[index];
            }
            return newValues;
        });

    };
    function convertIntoOneObject(array, formData) {
        if (array.length > 0) {

            var tableData = {

                clothId: array[0].cloth || 0,
                rate: array[0].rate || 0,
                m_panna: array[0].panna || 0,
                m1: array[1].cloth || 0,
                m1rate: array[1].rate || 0,
                m1_panna: array[1].panna || 0,
                m2: array[2].cloth || 0,
                m2rate: array[2].rate || 0,
                m2_panna: array[2].panna || 0,
                m3: array[3].cloth || 0,
                m3rate: array[3].rate || 0,
                m3_panna: array[3].panna || 0,
                // main cloth
                m_avg: array[0].avg || 0,
                // matching 1
                m1_avg: array[1].avg || 0,
                // matching 2
                m2_avg: array[2].avg || 0,
                // matching 3
                m3_avg: array[3].avg || 0,


                // Include formData fields
                sono: formData.sono,
                barcode: formData.barcode,
                ordt: formData.ordt,
                deldt: formData.deldt,
                party: formData.party,
                firm: formData.firm,
                price: formData.price,
                item: formData.item,
                schl: formData.schl,
                logo: formData.logo,
                extra: formData.extra,
                totQty: formData.totQty,
                outSrc: formData.outSrc,
                details: formData.details,
                transportId: formData.transportId,
                jobrate: formData.jobrate,
                size: formData.size,
                userId: formData.userId,
                qty: formData.qty,
                discount: formData.discount
            };
        }
        return tableData;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObject = convertIntoOneObject(rows, formData);
        // console.log(finalObject);
        dispatch(createSaleOrdEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Sale Order Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={SaleOrderList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Order Entry</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'SO No', name: 'sono', type: 'readOnly' },
                                    { label: 'Barcode', name: 'barcode' },
                                    { label: 'Order Date', name: 'ordt', type: 'date' },
                                    { label: 'Delivery Date', name: 'deldt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="party">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="party"
                                                    id="party"
                                                    name="party"
                                                    value={formData.party}
                                                    onChange={(e) => handleDropdownChange(e, 'party')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        partylist.data.length > 0 ? partylist.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.partyNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoParty} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="firm"
                                                    id="firm"
                                                    name="firm"
                                                    value={formData.firm}
                                                    onChange={(e) => handleDropdownChange(e, 'firm')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        firmlist.data.length > 0 ? firmlist.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.firmNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="price">Price List:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="price"
                                                    id="price"
                                                    name="price"
                                                    value={formData.price}
                                                    onChange={(e) => handleDropdownChange(e, 'price')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        pricelist.data.length > 0 ? pricelist.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.grpNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="item">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="item"
                                                    id="item"
                                                    name="item"
                                                    value={formData.item}
                                                    onChange={(e) => handleDropdownChange(e, 'item')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        itemlist.data.length > 0 ? itemlist.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.itemNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoItem} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="schl">School:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="schl"
                                                    id="schl"
                                                    name="schl"
                                                    value={formData.schl}
                                                    onChange={(e) => handleDropdownChange(e, 'schl')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        schlList.data.length > 0 ? schlList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.schoolNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoSchool} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="logo">Logo:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="logo"
                                                    id="logo"
                                                    name="logo"
                                                    value={formData.logo}
                                                    onChange={(e) => handleDropdownChange(e, 'logo')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        logolist.data.length > 0 ? logolist.data.map((val, index) => (
                                                            <MenuItem key={index} value={val.ID}>{val.logoNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoLogo} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Extra', name: 'extra' },
                                    { label: 'Total Quantity', name: 'totQty', type: 'readOnly' },
                                    { label: 'Discount(%)', name: 'discount' },
                                    { label: 'Out Source(+)%', name: 'outSrc' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                {[
                                    { label: 'Details', name: 'details' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        style={{ width: '80%', height: '100px', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', ...styled.input }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="transportId">Transport Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="transportId"
                                                    id="transportId"
                                                    name="transportId"
                                                    value={formData.transportId}
                                                    onChange={(e) => handleDropdownChange(e, 'transportId')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        transptlist.data.length > 0 ? transptlist.data.map((val, index) => (
                                                            <MenuItem key={index} value={val.ID}>{val.transportNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoTransport} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={8}>
                                    <TableContainer style={{
                                        width: isDesktop ? '100%' : '100%',
                                        marginLeft: isDesktop ? '10%' : '0%',
                                        overflow: 'hidden'
                                    }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Cloth Type</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Cloth</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                            {row.clothTypes}
                                                        </TableCell>

                                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                            <Select
                                                                name="cloth"
                                                                value={row.cloth}
                                                                onChange={(e) => handleDropdownChanged(e, index, 'cloth')}
                                                                sx={inputStyles}
                                                            >
                                                                <MenuItem value="">Select an option</MenuItem>
                                                                {/* Add more MenuItems based on your requirements */}
                                                                {
                                                                    clothlist.data.length > 0 ? clothlist.data.map((item, index) => (
                                                                        <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                                    )) : []
                                                                }
                                                            </Select>

                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNavitoCloth}
                                                                size='small'
                                                                style={{ marginLeft: 5 }}
                                                            >
                                                                New
                                                            </Button>

                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                            <TextField
                                                                name='rate'
                                                                value={row.rate}
                                                                onChange={(e) => handleInputChanged(e, index)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbers}
                                                            />

                                                        </TableCell>

                                                    </TableRow>
                                                ))}

                                            </TableBody>

                                        </Table>

                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                    <Table>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>Size</TableCell>
                                                {sizeItem.map((val, index) => (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>{val}</TableCell>
                                                ))}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>Quantity</TableCell>
                                                {sizeItem.map((val, index) => {
                                                    return (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                            <input
                                                                type="text"
                                                                value={inputValues[index]} // Set the value from the state
                                                                onChange={(event) => handleQtyChange(index, event)} // Handle input change
                                                                style={{ width: 40, padding: 1 }}
                                                            />
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                            {rows[0].cloth !== '' && (<TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>Avg</TableCell>
                                                {rows[0].avg.map((val, index) => (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                        <input type="text" value={val || '0'} style={{ width: 40, padding: 1 }} readOnly />
                                                    </TableCell>
                                                ))}
                                            </TableRow>)}

                                            {rows[1].cloth !== '' && (<TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>m1Avg</TableCell>
                                                {rows[1].avg.map((val, index) => (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                        <input type="text" value={val || '0'} style={{ width: 40, padding: 1 }} readOnly />
                                                    </TableCell>
                                                ))}
                                            </TableRow>)}

                                            {rows[2].cloth !== '' && (<TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>m2Avg</TableCell>
                                                {rows[2].avg.map((val, index) => (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                        <input type="text" value={val || '0'} style={{ width: 40, padding: 1 }} readOnly />
                                                    </TableCell>
                                                ))}
                                            </TableRow>)}

                                            {rows[3].cloth !== '' && (<TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>m3Avg</TableCell>
                                                {rows[3].avg.map((val, index) => (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                        <input type="text" value={val || '0'} style={{ width: 40, padding: 1 }} readOnly />
                                                    </TableCell>
                                                ))}
                                            </TableRow>)}
                                        </TableBody>
                                    </Table>
                                </Grid>


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default SaleOrderEntry;
